import { useCallback } from "react";

export interface ContextMenuItem {
  key: string;
  label: string;
  onClick: () => void;
}

export const useContextMenu = () => {
  const showContextMenu = useCallback(
    (e: React.MouseEvent, items: ContextMenuItem[]) => {
      e.preventDefault();

      // Remove any existing context menu
      const existingMenu = document.querySelector(".custom-context-menu");

      if (existingMenu && existingMenu.parentNode) {
        existingMenu.parentNode.removeChild(existingMenu);
      }

      const menu = document.createElement("div");

      menu.className = "custom-context-menu";
      menu.style.position = "fixed";
      menu.style.left = `${e.clientX}px`;
      menu.style.top = `${e.clientY}px`;
      menu.style.zIndex = "1000";
      menu.style.backgroundColor = "#fff";
      menu.style.border = "1px solid #e0e0e0";
      menu.style.borderRadius = "4px";
      menu.style.boxShadow = "0 2px 8px rgba(0,0,0,0.15)";
      menu.style.padding = "4px 0";
      menu.style.minWidth = "160px";

      items.forEach((item) => {
        const menuItem = document.createElement("div");

        menuItem.style.padding = "8px 16px";
        menuItem.style.cursor = "pointer";
        menuItem.style.color = "#333";
        menuItem.style.fontSize = "14px";
        menuItem.textContent = item.label;
        menuItem.onmouseover = () => {
          menuItem.style.backgroundColor = "#f5f5f5";
        };
        menuItem.onmouseout = () => {
          menuItem.style.backgroundColor = "transparent";
        };
        menuItem.onmousedown = () => {
          item.onClick();

          if (menu.parentNode) {
            menu.parentNode.removeChild(menu);
          }
        };
        menu.appendChild(menuItem);
      });

      document.body.appendChild(menu);

      // Close menu when clicking outside
      const closeMenu = (e: MouseEvent) => {
        if (!menu.contains(e.target as Node) && menu.parentNode) {
          menu.parentNode.removeChild(menu);
        }
      };

      document.addEventListener("click", closeMenu);

      return () => {
        document.removeEventListener("click", closeMenu);

        if (menu.parentNode) {
          menu.parentNode.removeChild(menu);
        }
      };
    },
    []
  );

  return { showContextMenu };
};
